
import enCommon from './en/common';
import frCommon from './fr/common';
import arCommon from './ar/common';

const messages = {
  en: {
    common: enCommon,
  },
  fr: {
    common: frCommon,
  },
  ar: {
    common: arCommon,
  },
};

export default messages;
